import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import TimeoutUtility from "../../contexts/TimeoutUtility";
import { validateField } from "../../contexts/Utils";
import { GetAllEmployees, getGPUbySn, TestGpuAssemblyApi } from "../../api";
import { Header, Button } from "../../components";
import "../../styles/AddPart.css";
import { Container, Col, Row } from "react-bootstrap";
import { useStateContext } from "../../contexts/ContextProvider";
import TextAreaField from "../../components/TextAreaField";
import TextInputField from "../../components/TextInputField";
import SelectField from "../../components/SelectField";
import { showSuccessToast, showErrorToast } from "../../components/ToastMesg";
import DateTimeField from "../../components/DateTimeField";

const TestGpuAssembly = () => {
  const navigate = useNavigate();
  const { storeG, userID } = useStateContext();
  const [getEmployees, setEmployees] = useState([]);
  const [gpuSn, setGpuSn] = useState("");
  const [formData, setFormData] = useState({
    assembly_id: 0,
    gpu_id: 0,
    so_id: 0,
    gpu_sn: "",
    part: "",
    gpu_name: "",
    specs: "",
    sku: "",
    box_id: "",
    lot_no: "",
    recv_date: "",
    employee: "Select Employee",
    power_on: false,
    video_out: false,
    memory: false,
    test: "PASS",
    comment: "",
    other: "",
    note: "",
  });
  const [oDatetime, setODatetime] = useState("");
  const [errors, setErrors] = useState({});
  const [loadBtn, setLoadBtn] = useState(false);

  const handleBackClick = () => {
    TimeoutUtility.resetTimeout();
    navigate("/GpuWb");
  };

  const handleChange = async (e) => {
    const { name, value } = e.target;
    if (name === "gpu_sn") {
      setGpuSn(value);
      if (value.length > 10 && value.length < 18) {
        await getGPUbySn(value)
          .then((resp) => {
            if (resp?.data && resp?.data?.pull_scan_date) {
              setFormData((prev) => ({
                ...prev,
                assembly_id: resp.data.assembly_id,
                gpu_id: resp.data.gpu_id,
                so_id: resp.data.so_id,
                gpu_sn: resp.data.gpu_sn,
                part: `${resp.data.part_number} - ${resp.data.part_description}`,
                gpu_name: resp.data.name,
                specs: resp.data.specs,
                sku: resp.data.sku,
                box_id: resp.data.box_id,
                lot_no: resp.data.lot_no,
                recv_date: resp.data.recv_scan_date.slice(0, -1),
              }));
              var now = new Date();
              now.setMinutes(now.getMinutes() - now.getTimezoneOffset());
              setODatetime(now.toISOString().slice(0, 19));
            } else
              setFormData((prev) => ({ ...prev, [name]: value, gpu_id: 0 }));
          })
          .catch((err) => console.log(err.message));
      } else setFormData((prev) => ({ ...prev, [name]: value, gpu_id: 0 }));
    } else setFormData((prev) => ({ ...prev, [name]: value }));

    const error = validateField(name, value, name);
    setErrors((prev) => ({ ...prev, [name]: error }));
  };

  const handleSelectChange = (option, e) => {
    if (option && option.value) {
      setFormData((prev) => ({ ...prev, [e.name]: option }));
      const error = validateField(e.name, option, e.name);
      setErrors((prev) => ({ ...prev, [e.name]: error }));
    } else setFormData((prev) => ({ ...prev, [e.name]: "select" }));
  };

  const handleRadioChange = (e) => {
    const name = e.target.value;
    setFormData((prev) => ({ ...prev, test: name }));
  };

  const handleCheckChange = (e) => {
    const name = e.target.name;
    setFormData((prev) => ({ ...prev, [name]: !formData[name] }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    TimeoutUtility.resetTimeout();
    setLoadBtn(true);
    const newErrors = {};
    Object.keys(formData).forEach((key) => {
      const error = validateField(key, formData[key], key);
      if (error) newErrors[key] = error;
    });
    if (!formData.gpu_id) newErrors.gpu_sn = "Invalid GPU SN!";
    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) {
      setLoadBtn(false);
      return;
    }
    const reqData = {
      assembly_id: formData.assembly_id,
      gpu_id: formData.gpu_id,
      employee_id: formData.employee.value,
      user_id: userID,
      datetime: oDatetime,
      power_on: formData.power_on,
      video_out: formData.video_out,
      memory: formData.memory,
      test_result: formData.test,
      remarks: formData.comment,
      other: formData.other,
      notes: formData.note,
    };
    try {
      const response = await TestGpuAssemblyApi(reqData);
      if (response.success) {
        showSuccessToast("Success!", "Assembly Tested successfully!");
        navigate("/GpuWb");
      } else
        showErrorToast("Error!", "Assembly failed to Test!" + response.message);
    } catch (err) {
      showErrorToast("Error!", "Assembly did not Test!");
    } finally {
      setLoadBtn(false);
    }
  };

  useEffect(() => {
    async function fetchData() {
      if (storeG?.store_id) {
        TimeoutUtility.resetTimeout();
        await GetAllEmployees()
          .then((resp) => {
            const employeeOptions = resp.data.map((item) => ({
              label: item.name,
              value: item.employee_id,
            }));
            setEmployees(employeeOptions || []);
          })
          .catch((err) => console.log(err.message));
      }
    }
    fetchData();
  }, [storeG]);

  return (
    <div className="m-0 md:m-4 p-4 md:p-8 main-div-bg">
      <Header title="TEST GPU ASSEMBLY" />
      <form>
        <Container className="g-0 form-container" fluid="true">
          <Row xs={1} sm={1} className="p-0 justify-content-center">
            <Col xl={10} lg={12} className="container-col">
              <TextInputField
                label="GPU SN:"
                name="gpu_sn"
                value={gpuSn}
                onChange={handleChange}
                placeholder="GPU SN"
              />
            </Col>
          </Row>
          <Row xs={1} sm={1} className="p-0 justify-content-center">
            <Col xl={5} lg={6} className="container-col">
              <div className="col-lg-12">
                <TextInputField
                  label="SO:"
                  name="so_id"
                  value={formData.so_id}
                  placeholder="Name"
                  disabled
                />
                <TextInputField
                  label="Part:"
                  name="part"
                  value={formData.part}
                  placeholder="Part"
                  disabled
                />
                <TextInputField
                  label="Name:"
                  name="gpu_name"
                  value={formData.gpu_name}
                  placeholder="Name"
                  disabled
                />
                <TextInputField
                  label="Specs:"
                  name="specs"
                  value={formData.specs}
                  placeholder="Specs"
                  disabled
                />
                <TextInputField
                  label="SKU:"
                  name="sku"
                  value={formData.sku}
                  placeholder="SKU"
                  disabled
                />
                <TextInputField
                  label="Box ID:"
                  name="box_id"
                  value={formData.box_id}
                  placeholder="Box ID"
                  disabled
                />
                <TextInputField
                  label="Lot #:"
                  name="lot_no"
                  value={formData.lot_no}
                  placeholder="Lot #"
                  disabled
                />
                <DateTimeField
                  label="Recv Datetime:"
                  name="recv_date"
                  value={formData.recv_date}
                  placeholder="DateTime"
                  now={false}
                  formField={true}
                  disabled
                />
              </div>
            </Col>
            <Col xl={5} lg={6} className="container-col">
              <div className="col-lg-12">
                <DateTimeField
                  label="Test Datetime:"
                  name="test_date"
                  value={oDatetime}
                  placeholder="DateTime"
                  now={false}
                  formField={true}
                  disabled
                />
                <SelectField
                  label="Test Operator:"
                  name="employee"
                  value={formData.employee}
                  options={getEmployees}
                  onChange={handleSelectChange}
                  placeholder="Operator"
                  compulsory={true}
                  error={errors.employee}
                  isDisabled={!formData.gpu_id}
                />
                <label className="label mt-3">Test Result:</label>
                <div className="text-md flex gap-4 justify-content-center mr-8 mt-2">
                  <label>
                    <input
                      type="radio"
                      value="PASS"
                      id="auto"
                      name="type"
                      onChange={handleRadioChange}
                      style={{ marginRight: "4px" }}
                      checked={formData.test === "PASS"}
                      disabled={!formData.gpu_id}
                    />
                    PASS
                  </label>
                  <label>
                    <input
                      type="radio"
                      value="FAIL"
                      id="auto"
                      name="type"
                      onChange={handleRadioChange}
                      style={{ marginRight: "4px" }}
                      checked={formData.test === "FAIL"}
                      disabled={!formData.gpu_id}
                    />
                    FAIL
                  </label>
                </div>
                <label className="label mt-3">Test Result:</label>
                <div className="text-md flex gap-4 justify-content-center mr-8 mt-2">
                  <label>
                    <input
                      type="checkbox"
                      name="power_on"
                      onChange={handleCheckChange}
                      style={{ marginRight: "4px" }}
                      checked={formData.power_on}
                      disabled={!formData.gpu_id}
                    />
                    Power On
                  </label>
                  <label>
                    <input
                      type="checkbox"
                      name="video_out"
                      onChange={handleCheckChange}
                      style={{ marginRight: "4px" }}
                      checked={formData.video_out}
                      disabled={!formData.gpu_id}
                    />
                    Video Out
                  </label>
                  <label>
                    <input
                      type="checkbox"
                      name="memory"
                      onChange={handleCheckChange}
                      style={{ marginRight: "4px" }}
                      checked={formData.memory}
                      disabled={!formData.gpu_id}
                    />
                    Memory
                  </label>
                </div>
                <TextInputField
                  label="Comments:"
                  name="comment"
                  value={formData.comment}
                  onChange={handleChange}
                  placeholder="Comments"
                  error={errors.comment}
                  disabled={!formData.gpu_id}
                />
                <TextInputField
                  label="Other:"
                  name="other"
                  value={formData.other}
                  onChange={handleChange}
                  placeholder="Other"
                  error={errors.other}
                  disabled={!formData.gpu_id}
                />
                <TextAreaField
                  label="Note:"
                  name="note"
                  value={formData.note}
                  onChange={handleChange}
                  placeholder="Note"
                  error={errors.note}
                  disabled={!formData.gpu_id}
                />
              </div>
            </Col>
          </Row>
        </Container>
      </form>
      <Row md={"auto"} className="justify-content-center pt-12">
        <Button
          margin="10px"
          padding="20px"
          text="Create"
          onClick={handleSubmit}
          disabled={loadBtn}
        />
        <Button
          margin="10px"
          padding="20px"
          text="Back"
          onClick={handleBackClick}
        />
      </Row>
    </div>
  );
};

export default TestGpuAssembly;
